const checkSameUrl = (firstUrl: string, secondUrl: string): boolean => {
  const parsedUrlFirst = new URL(firstUrl);
  const parsedUrlSecond = new URL(secondUrl);
  return parsedUrlFirst.pathname === parsedUrlSecond.pathname;
};

export default checkSameUrl;
